export default "__VITE_ASSET__CQX4LooL__"